import gsap from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger';



gsap.registerPlugin(ScrollTrigger);



const PRICING_ORIGIN = '100% 100%';

const PROCESS_ORIGIN = '0% 100%';



const DECORATION_ANCHOR_SELECTOR =
	'.pricing__decoration, .process__decoration, .faq__decoration, .cs-testimonials__decoration, .client-testimonials-panel__decoration, .cs-grid__decoration, .cs-detail-article__decoration, .about-journey__decoration, .about-dark-panel__decoration, .services-capabilities__decoration, .services-intro__decoration, .solution__decoration';



/**

 * @param {HTMLElement} section

 */

const bindSection = (section) => {

	const isProcess = section.classList.contains('section--process');

	const isFaq = section.classList.contains('section--faq');

	const isCsTestimonials = section.classList.contains('section--cs-testimonials');
	const isThankYouTestimonials = section.classList.contains('section--client-testimonials--thank-you');
	const isThankYouSuccessStories = section.classList.contains('section--cs-grid--thank-you');

	const isAboutDarkPanel = section.classList.contains('section--about-dark-panel');
	const isServicesCapabilities = section.classList.contains('section--services-capabilities');
	const isServicesIntro = section.classList.contains('section--services-intro');

	const motions = section.querySelectorAll('.js-pricing-decoration');



	if (!motions.length) {

		return null;

	}



	const pairs = [];



	motions.forEach((motion) => {

		const path = motion.querySelector('.js-pricing-decoration-path');

		const anchor = motion.closest(DECORATION_ANCHOR_SELECTOR);



		if (path && anchor) {

			pairs.push({ motion, path, anchor });

		}

	});



	if (!pairs.length) {

		return null;

	}



	// Left-placed ribbons use flip + 0% 100% origin; right-placed (pricing, article) use 100% 100%

	const useLeftOrigin = isProcess || isFaq || isThankYouTestimonials || isThankYouSuccessStories || isServicesIntro;

	const origin = isServicesCapabilities
		? '100% 0%'
		: isAboutDarkPanel
			? '100% 50%'
			: useLeftOrigin
				? PROCESS_ORIGIN
				: PRICING_ORIGIN;

	const entranceRotation = isServicesCapabilities || useLeftOrigin ? -12 : 12;



	pairs.forEach(({ motion, path }) => {

		gsap.set(motion, { transformOrigin: origin });

		gsap.set(path, { transformOrigin: origin, opacity: 0.1 });

	});



	let idleTweens = [];

	let glowTweens = [];



	const entrance = gsap.timeline({

		scrollTrigger: {

			trigger: section,

			start: 'top 80%',

			once: true,

		},

		defaults: { ease: 'power3.out' },

		onComplete: () => {

			pairs.forEach(({ motion, path }) => {

				idleTweens.push(

					gsap.to(motion, {

						y: -7,

						duration: 2.6,

						ease: 'sine.inOut',

						yoyo: true,

						repeat: -1,

					}),

				);



				glowTweens.push(

					gsap.to(path, {

						opacity: 0.17,

						duration: 2.6,

						ease: 'sine.inOut',

						yoyo: true,

						repeat: -1,

					}),

				);

			});

		},

	});



	pairs.forEach(({ motion, path }, index) => {

		const offset = index * 0.08;



		entrance.fromTo(

			motion,

			{ y: 36, rotation: entranceRotation, autoAlpha: 0 },

			{ y: 0, rotation: 0, autoAlpha: 1, duration: 1.15 },

			offset,

		);



		entrance.fromTo(

			path,

			{ scale: 0.55, opacity: 0 },

			{ scale: 1, opacity: 0.1, duration: 0.9, ease: 'back.out(1.6)' },

			offset + 0.4,

		);

	});



	const anchors = pairs.map(({ anchor }) => anchor);



	const parallax = gsap.fromTo(

		anchors,

		{ y: 12 },

		{

			y: -22,

			ease: 'none',

			scrollTrigger: {

				trigger: section,

				start: 'top bottom',

				end: 'bottom top',

				scrub: 0.85,

			},

		},

	);



	return () => {

		entrance.scrollTrigger?.kill();

		parallax.scrollTrigger?.kill();

		idleTweens.forEach((tween) => tween.kill());

		glowTweens.forEach((tween) => tween.kill());

		gsap.killTweensOf([...pairs.map((p) => p.motion), ...pairs.map((p) => p.path), ...anchors]);

		gsap.set([...pairs.map((p) => p.motion), ...pairs.map((p) => p.path), ...anchors], {

			clearProps: 'all',

		});

		pairs.forEach(({ path }) => {

			path.style.opacity = '0.1';

		});

	};

};



export const initPricingDecoration = () => {

	const sections = document.querySelectorAll(
		'.section--pricing, .section--process, .section--faq, .section--cs-testimonials, .section--client-testimonials--thank-you, .section--cs-grid--thank-you, .section--cs-grid-carousel, .section--cs-detail-article, .section--about-journey, .section--about-dark-panel, .section--services-capabilities, .section--services-intro, .section--solution',
	);

	if (!sections.length) {

		return;

	}



	const cleanups = [];



	gsap.matchMedia().add('(prefers-reduced-motion: no-preference) and (min-width: 1100px)', () => {

		sections.forEach((section) => {

			const cleanup = bindSection(section);

			if (cleanup) {

				cleanups.push(cleanup);

			}

		});



		return () => {

			cleanups.forEach((fn) => fn());

		};

	});

};

